export default __webpack_public_path__ + "static/media/BANNER03.59a3a6e6.png";